<template>
  <div class="TrialHeaderBox">
    <div class="the_trial_head">
      <div class="tips">还款试算</div>
      <div class="the_base">
        <div class="angle"></div>
        <p class="tip_money">贷款金额</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TrialHeader',
  data() {
    return {};
  },
};
</script>
<style scoped>
p {
  margin: 0;
}
.table_head p span {
  font-family: PingFangSC-Regular;
  font-size: 13px;
  color: #1c2438;
  letter-spacing: 0;
  text-align: center;
}
.the_trial_head {
  width: 100%;
  height: 113px;
  background: #f55646;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.the_base {
  width: 345px;
  height: 44px;
  background: #ffffff;
  margin-top: 21px;
  border-radius: 8px 8px 0 0;
  position: relative;
}
.angle {
  width: 0px;
  height: 0px;
  background: #009999;
  border-width: 14px;
  border-style: solid;
  border-color: #f55646 #f55646 #fff #f55646;
  margin: -28px auto;
}
.trial {
  margin: 31px 0 4px 0;
  font-family: PingFangSC-Medium;
  font-size: 17px;
}
.tips {
  margin: 20px 0 10px 0;
  color: #fff;
  font-size: 17px;
  font-weight: bold;
  font-family: 'PingFang SC', miui, system-ui, -apple-system, BlinkMacSystemFont,
    Helvetica Neue, Helvetica, sans-serif;
}
.tip_money {
  position: absolute;
  bottom: 0;
  left: 15px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #1c2438;
}
</style>
